import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const Label = ({ children, htmlFor, required, srOnly = false }) => {
  return (
    <label
      htmlFor={htmlFor}
      className={classNames({
        "label--required": required,
        "sr-only": srOnly === true,
        "sr-only-mobile": srOnly === "mobile",
        "sr-only-desktop": srOnly === "desktop",
      })}
    >
      {children}
    </label>
  );
};

Label.propTypes = {
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string.isRequired,
  required: PropTypes.bool,
  srOnly: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(["desktop", "mobile"]),
  ]),
};

export default Label;
